<template>
  <div
    class="form-group"
    :class="[
      {'has-label': label || $slots.label},
      { focused: focused }
    ]"
  >
  <slot name="label">
    <label v-if="label" class="form-control-label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
    </label>
</slot>


    <slot v-bind="slotData">
      <textarea
        :value="value"
        v-on="listeners"
        v-bind="$attrs"
        class="form-control"
        :class="[inputClasses]"
        :style="[
          { resize: noResize ? 'none' : 'vertical' }
        ]"
      ></textarea>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "base-text-area",
  props: {
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    inputClasses: {
      type: String,
      description: "Input css classes",
    },
    value: {
      type: [String, Number],
      description: "Input value",
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    noResize: {
      type: Boolean,
      description: "Whether textarea is resizable",
      default: false,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur,
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners,
      };
    },
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    },
  },
};
</script>
<style></style>
